import React from 'react'
import * as S from "./style"

export const Form = () => {
    return (
        <S.Container className="container">
            <h1>Entre em Contato</h1>
            <p>Envie seu comentário, crítica, elogio, sugestão, ou mesmo sua dúvida neste formulário. Teremos grande prazer em atendê-lo.</p>
            
            <form>
                <label htmlFor="nome">Nome: </label>
                <input id="nome" type="text"/>

                <label htmlFor="email">Email: </label>
                <input id="email" type="email"/>

                <label htmlFor="telefone">Telefone: </label>
                <input id="telefone" type="tel"/>
                
                <label htmlFor="mensagem">Mensagem: </label>
                <textarea id="mensagem"/>

                <button type="submit">Enviar</button>


            </form>

        </S.Container>
    )
}
